import { press } from './units';
// static pressure from elevation: p = p0 - (z - z0) / 10  (1 bar ≈ 10 m water column)
export const PN = [4, 6, 10, 16, 25];
export const PMIN = { drink: 2.0, irr: 1.5 };
export const DROP_TOL = 0.8;
export const LOW_ACOUSTIC = 1.8;
const num = (v) => (v === '' || v == null || !Number.isFinite(+v) ? null : +v);

// pipe crown height: ground a.s.l. minus laying depth when known
export const zOf = (f) => { const g = num(f?.elev?.v); if (g == null) return null; const d = num(f.depth); return d != null ? g - d : g; };

// fittings reachable from the source through pipes (fid points / host pipe)
function reach(src, pipes, fittings) {
  const seen = new Set([src]), queue = [src];
  const ends = pipes.map((p) => [...p.points.filter((x) => x && !Array.isArray(x) && x.fid).map((x) => x.fid), ...fittings.filter((f) => f.hostPipe === p.id).map((f) => f.id)]);
  while (queue.length) {
    const id = queue.shift();
    ends.forEach((ids) => { if (ids.includes(id)) ids.forEach((o) => { if (!seen.has(o)) { seen.add(o); queue.push(o); } }); });
  }
  return seen;
}

export function pressureMap(cfg, pipes = [], fittings = []) {
  const src = cfg?.srcId && fittings.find((f) => f.id === cfg.srcId);
  const p0 = num(cfg?.bar), z0 = zOf(src);
  if (!src || p0 == null || z0 == null) return null;
  const pn = num(cfg.pn) || 10, min = num(cfg.min) ?? PMIN[cfg.mode || 'drink'];
  const out = {};
  reach(src.id, pipes, fittings).forEach((id) => {
    const f = fittings.find((x) => x.id === id), z = zOf(f);
    if (z == null) return;
    const bar = p0 - (z - z0) / 10, ist = num(f.pIst), drop = ist != null ? bar - ist : null;
    out[id] = { bar, z, ist, drop, status: bar > pn ? 'over' : bar < min ? 'low' : 'ok', leak: drop != null && drop > DROP_TOL, quiet: (ist ?? bar) < LOW_ACOUSTIC };
  });
  return { src, p0, z0, pn, min, nodes: out, at: (h) => p0 - (h - z0) / 10 };
}

export const fmtBar = (v) => press(v);
